import type { ReactNode } from 'react'

export function Modal({
  title,
  onClose,
  children,
  footer,
  wide = false,
}: {
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  wide?: boolean
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative w-full ${wide ? 'max-w-2xl' : 'max-w-md'} max-h-[90vh] flex flex-col bg-surface-light dark:bg-surface-dark rounded-2xl shadow-float dark:border dark:border-border-dark`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-border-light dark:border-border-dark">
          <h2 className="text-base font-semibold text-text-light dark:text-text-dark">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-lg text-subtle-light dark:text-subtle-dark hover:text-text-light dark:hover:text-text-dark hover:bg-primary/5"
            aria-label="Close"
          >
            <span className="material-icons text-xl">close</span>
          </button>
        </div>
        <div className="px-6 py-4 overflow-y-auto">{children}</div>
        {footer && (
          <div className="flex justify-end gap-2 px-6 py-4 border-t border-border-light dark:border-border-dark">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}

export function Drawer({
  title,
  onClose,
  children,
}: {
  title: string
  onClose: () => void
  children: ReactNode
}) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-xl h-full flex flex-col bg-surface-light dark:bg-surface-dark shadow-float dark:border-l dark:border-border-dark">
        <div className="flex items-center justify-between px-6 py-4 border-b border-border-light dark:border-border-dark">
          <h2 className="text-base font-semibold text-text-light dark:text-text-dark truncate">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-lg text-subtle-light dark:text-subtle-dark hover:text-text-light dark:hover:text-text-dark hover:bg-primary/5"
            aria-label="Close"
          >
            <span className="material-icons text-xl">close</span>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">{children}</div>
      </div>
    </div>
  )
}
